import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useEffect, useState } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $isLinkNode } from "@lexical/link";
import { $getNearestNodeOfType, mergeRegister } from "@lexical/utils";
import { $createParagraphNode, $getSelection, $insertNodes, $isRangeSelection } from "lexical";
import { $setBlocksType } from "@lexical/selection";
import { TableNode } from "@lexical/table";
import { Box } from "../../../../Box/index.js";
import { Icon } from "../../../../Icon/index.js";
import { DropdownButton } from "../../../../DropdownButton/index.js";
import { ToolbarButton } from "../common/index.js";
import { getSelectedNode } from "../../utils/index.js";
import { $createCodeBlockNode, $createMentionNode, $createReferenceNode } from "../../nodes/index.js";
import { useDialog } from "../../../../hooks/index.js";
import { LinkDialog, QuoteDialog, TableDialog } from "./components/index.js";
import { useSymbols } from "./hooks/index.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function LinkAndTablePlugin_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else LinkAndTablePlugin_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const LinkAndTablePlugin = (t0)=>{
    const $ = c(69);
    const { link, table, reference, codeBlock, quote, symbols: symbolsNode, mention } = t0;
    const [editor] = useLexicalComposerContext();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            link: false,
            table: false,
            quote: false
        };
        $[0] = t1;
    } else t1 = $[0];
    const { onOpen, dialogsState, onClose } = useDialog(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            table: false,
            link: false,
            reference: false,
            code: false
        };
        $[1] = t2;
    } else t2 = $[1];
    const [activeParams, setActiveParams] = useState(t2);
    const [selectionText, setSelectionText] = useState("");
    const [selectionUrl, setSelectionUrl] = useState("");
    const symbols = useSymbols(editor);
    let t3;
    if ($[2] !== editor) {
        t3 = ()=>{
            editor.read(()=>{
                const selection = $getSelection();
                if ($isRangeSelection(selection)) {
                    const textContent = selection.getTextContent();
                    const node = getSelectedNode(selection);
                    const parent = node.getParent();
                    let url = "";
                    if (textContent) {
                        if ($isLinkNode(node)) url = node.exportJSON().url;
                        if ($isLinkNode(parent)) url = parent.exportJSON().url;
                        if (url) setSelectionUrl(url);
                        setSelectionText(textContent);
                    } else {
                        setSelectionText("");
                        setSelectionUrl("");
                    }
                    const tableNode = $getNearestNodeOfType(node, TableNode);
                    null !== tableNode ? setActiveParams(_temp) : setActiveParams(_temp2);
                    "link" === node.getType() || (null == parent ? void 0 : parent.getType()) === "link" ? setActiveParams(_temp3) : setActiveParams(_temp4);
                    "reference-node" === node.getType() || (null == parent ? void 0 : parent.getType()) === "reference-node" ? setActiveParams(_temp5) : setActiveParams(_temp6);
                    "code-block-node" === node.getType() || (null == parent ? void 0 : parent.getType()) === "code-block-node" ? setActiveParams(_temp7) : setActiveParams(_temp8);
                }
            });
        };
        $[2] = editor;
        $[3] = t3;
    } else t3 = $[3];
    const updateToolbar = t3;
    let t4;
    let t5;
    if ($[4] !== editor || $[5] !== updateToolbar) {
        t4 = ()=>mergeRegister(editor.registerUpdateListener((t6)=>{
                const { editorState } = t6;
                editorState.read(()=>{
                    updateToolbar();
                });
            }));
        t5 = [
            editor,
            updateToolbar
        ];
        $[4] = editor;
        $[5] = updateToolbar;
        $[6] = t4;
        $[7] = t5;
    } else {
        t4 = $[6];
        t5 = $[7];
    }
    useEffect(t4, t5);
    let t6;
    if ($[8] !== onClose) {
        t6 = ()=>{
            onClose("link")();
            setSelectionText("");
            setSelectionUrl("");
        };
        $[8] = onClose;
        $[9] = t6;
    } else t6 = $[9];
    const handleLinkDialogClose = t6;
    let t7;
    if ($[10] !== editor) {
        t7 = ()=>{
            editor.update(_temp1);
        };
        $[10] = editor;
        $[11] = t7;
    } else t7 = $[11];
    const handleReferenceClick = t7;
    let t8;
    if ($[12] !== editor) {
        t8 = ()=>{
            editor.update(_temp12);
        };
        $[12] = editor;
        $[13] = t8;
    } else t8 = $[13];
    const handleBlockCodeClick = t8;
    let t9;
    if ($[14] !== onClose) {
        t9 = ()=>{
            onClose("quote")();
            setSelectionText("");
        };
        $[14] = onClose;
        $[15] = t9;
    } else t9 = $[15];
    const handleQuoteDialogClose = t9;
    let t10;
    if ($[16] !== editor) {
        t10 = ()=>{
            editor.update(_temp13);
        };
        $[16] = editor;
        $[17] = t10;
    } else t10 = $[17];
    const handleMentionClick = t10;
    let t11;
    if ($[18] !== activeParams || $[19] !== link || $[20] !== onOpen) {
        t11 = link && /*#__PURE__*/ jsx(ToolbarButton, {
            onClick: onOpen("link"),
            tooltip: "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443",
            children: /*#__PURE__*/ jsx(Icon, {
                name: "chain_outline",
                size: "16",
                color: activeParams.link ? "original.brand.primary" : "text.light.primary"
            })
        });
        $[18] = activeParams;
        $[19] = link;
        $[20] = onOpen;
        $[21] = t11;
    } else t11 = $[21];
    let t12;
    if ($[22] !== activeParams || $[23] !== onOpen || $[24] !== table) {
        t12 = table && /*#__PURE__*/ jsx(ToolbarButton, {
            onClick: onOpen("table"),
            tooltip: "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0442\u0430\u0431\u043B\u0438\u0446\u0443",
            children: /*#__PURE__*/ jsx(Icon, {
                name: "table_header_outline",
                size: "16",
                color: activeParams.table ? "original.brand.primary" : "text.light.primary"
            })
        });
        $[22] = activeParams;
        $[23] = onOpen;
        $[24] = table;
        $[25] = t12;
    } else t12 = $[25];
    let t13;
    if ($[26] !== activeParams || $[27] !== handleReferenceClick || $[28] !== reference) {
        t13 = reference && /*#__PURE__*/ jsx(ToolbarButton, {
            onClick: handleReferenceClick,
            tooltip: "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0431\u043B\u043E\u043A \u0441\u043F\u0440\u0430\u0432\u043A\u0438",
            children: /*#__PURE__*/ jsx(Icon, {
                name: "vkhrtek_reference",
                color: activeParams.reference ? "original.brand.primary" : "text.light.primary",
                size: "16"
            })
        });
        $[26] = activeParams;
        $[27] = handleReferenceClick;
        $[28] = reference;
        $[29] = t13;
    } else t13 = $[29];
    let t14;
    if ($[30] !== activeParams || $[31] !== codeBlock || $[32] !== handleBlockCodeClick) {
        t14 = codeBlock && /*#__PURE__*/ jsx(ToolbarButton, {
            onClick: handleBlockCodeClick,
            tooltip: "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0431\u043B\u043E\u043A \u043A\u043E\u0434\u0430",
            children: /*#__PURE__*/ jsx(Icon, {
                name: "vkhrtek_code_block",
                size: "16",
                color: activeParams.code ? "original.brand.primary" : "text.light.primary"
            })
        });
        $[30] = activeParams;
        $[31] = codeBlock;
        $[32] = handleBlockCodeClick;
        $[33] = t14;
    } else t14 = $[33];
    let t15;
    if ($[34] !== onOpen || $[35] !== quote) {
        t15 = quote && /*#__PURE__*/ jsx(ToolbarButton, {
            onClick: onOpen("quote"),
            tooltip: "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0446\u0438\u0442\u0430\u0442\u0443",
            children: /*#__PURE__*/ jsx(Icon, {
                name: "quote_closing",
                size: "16",
                color: "text.light.primary"
            })
        });
        $[34] = onOpen;
        $[35] = quote;
        $[36] = t15;
    } else t15 = $[36];
    let t16;
    if ($[37] !== symbols || $[38] !== symbolsNode) {
        t16 = symbolsNode && /*#__PURE__*/ jsx(DropdownButton, {
            menuItems: symbols,
            variant: "tertiaryLight",
            verticalPosition: "bottom",
            horizontalPosition: "left",
            button: _temp14
        });
        $[37] = symbols;
        $[38] = symbolsNode;
        $[39] = t16;
    } else t16 = $[39];
    let t17;
    if ($[40] !== handleMentionClick || $[41] !== mention) {
        t17 = mention && /*#__PURE__*/ jsx(ToolbarButton, {
            onClick: handleMentionClick,
            tooltip: "\u0423\u043F\u043E\u043C\u0438\u043D\u0430\u043D\u0438\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F",
            children: /*#__PURE__*/ jsx(Icon, {
                name: "vkhrtek_at",
                size: "16",
                color: "text.light.primary"
            })
        });
        $[40] = handleMentionClick;
        $[41] = mention;
        $[42] = t17;
    } else t17 = $[42];
    let t18;
    if ($[43] !== dialogsState.link || $[44] !== editor || $[45] !== handleLinkDialogClose || $[46] !== selectionText || $[47] !== selectionUrl) {
        t18 = dialogsState.link && /*#__PURE__*/ jsx(LinkDialog, {
            editor: editor,
            open: dialogsState.link,
            onClose: handleLinkDialogClose,
            selectionText: selectionText,
            selectionUrl: selectionUrl
        });
        $[43] = dialogsState.link;
        $[44] = editor;
        $[45] = handleLinkDialogClose;
        $[46] = selectionText;
        $[47] = selectionUrl;
        $[48] = t18;
    } else t18 = $[48];
    let t19;
    if ($[49] !== dialogsState.table || $[50] !== editor || $[51] !== onClose) {
        t19 = dialogsState.table && /*#__PURE__*/ jsx(TableDialog, {
            editor: editor,
            open: dialogsState.table,
            onClose: onClose("table")
        });
        $[49] = dialogsState.table;
        $[50] = editor;
        $[51] = onClose;
        $[52] = t19;
    } else t19 = $[52];
    let t20;
    if ($[53] !== dialogsState.quote || $[54] !== editor || $[55] !== handleQuoteDialogClose || $[56] !== selectionText) {
        t20 = dialogsState.quote && /*#__PURE__*/ jsx(QuoteDialog, {
            editor: editor,
            open: dialogsState.quote,
            onClose: handleQuoteDialogClose,
            selectionText: selectionText
        });
        $[53] = dialogsState.quote;
        $[54] = editor;
        $[55] = handleQuoteDialogClose;
        $[56] = selectionText;
        $[57] = t20;
    } else t20 = $[57];
    let t21;
    if ($[58] !== t11 || $[59] !== t12 || $[60] !== t13 || $[61] !== t14 || $[62] !== t15 || $[63] !== t16 || $[64] !== t17 || $[65] !== t18 || $[66] !== t19 || $[67] !== t20) {
        t21 = /*#__PURE__*/ jsxs(Box, {
            display: "flex",
            alignItems: "center",
            gap: "2",
            children: [
                t11,
                t12,
                t13,
                t14,
                t15,
                t16,
                t17,
                t18,
                t19,
                t20
            ]
        });
        $[58] = t11;
        $[59] = t12;
        $[60] = t13;
        $[61] = t14;
        $[62] = t15;
        $[63] = t16;
        $[64] = t17;
        $[65] = t18;
        $[66] = t19;
        $[67] = t20;
        $[68] = t21;
    } else t21 = $[68];
    return t21;
};
function _temp(prev) {
    return _object_spread_props(_object_spread({}, prev), {
        table: true
    });
}
function _temp2(prev_0) {
    return _object_spread_props(_object_spread({}, prev_0), {
        table: false
    });
}
function _temp3(prev_1) {
    return _object_spread_props(_object_spread({}, prev_1), {
        link: true
    });
}
function _temp4(prev_2) {
    return _object_spread_props(_object_spread({}, prev_2), {
        link: false
    });
}
function _temp5(prev_3) {
    return _object_spread_props(_object_spread({}, prev_3), {
        reference: true
    });
}
function _temp6(prev_4) {
    return _object_spread_props(_object_spread({}, prev_4), {
        reference: false
    });
}
function _temp7(prev_5) {
    return _object_spread_props(_object_spread({}, prev_5), {
        code: true
    });
}
function _temp8(prev_6) {
    return _object_spread_props(_object_spread({}, prev_6), {
        code: false
    });
}
function _temp9() {
    return $createParagraphNode();
}
function _temp0() {
    return $createReferenceNode();
}
function _temp1() {
    const selection_0 = $getSelection();
    if ($isRangeSelection(selection_0)) {
        const node_0 = getSelectedNode(selection_0);
        const parent_0 = node_0.getParent();
        if ("reference-node" === node_0.getType() || (null == parent_0 ? void 0 : parent_0.getType()) === "reference-node") return void $setBlocksType(selection_0, _temp9);
        if ("root" === node_0.getType()) return void $insertNodes([
            $createReferenceNode()
        ]);
        $setBlocksType(selection_0, _temp0);
    }
}
function _temp10() {
    return $createParagraphNode();
}
function _temp11() {
    return $createCodeBlockNode();
}
function _temp12() {
    const selection_1 = $getSelection();
    if ($isRangeSelection(selection_1)) {
        const node_1 = getSelectedNode(selection_1);
        const parent_1 = node_1.getParent();
        if ("code-block-node" === node_1.getType() || (null == parent_1 ? void 0 : parent_1.getType()) === "code-block-node") return void $setBlocksType(selection_1, _temp10);
        if ("root" === node_1.getType()) return void $insertNodes([
            $createCodeBlockNode()
        ]);
        $setBlocksType(selection_1, _temp11);
    }
}
function _temp13() {
    const selection_2 = $getSelection();
    if ($isRangeSelection(selection_2)) {
        const mentionNode = $createMentionNode();
        $insertNodes([
            mentionNode
        ]);
    }
}
function _temp14(t0) {
    const { onClick } = t0;
    return /*#__PURE__*/ jsx(ToolbarButton, {
        onClick: onClick,
        tooltip: "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0441\u043F\u0435\u0446\u0441\u0438\u043C\u0432\u043E\u043B",
        children: /*#__PURE__*/ jsx(Icon, {
            name: "vkhrtek_omega",
            size: "16",
            color: "text.light.primary"
        })
    });
}
export { LinkAndTablePlugin };
